import {Component, Injector, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import { RegistrationService } from '../../services/registration.service';
import { UserFormModel } from '../../models/user-form.model';
import { ActivationCodeModel } from '../../models/activation-code.model';
import { TeamModel } from '../../../team/models/team.model';
import { RegistrationValidationErrors } from '../../responses/RegistrationValidationErrors';
import { AuthService } from '../../services/auth.service';
import { AppService } from '../../../app.service';
import { DialogService } from '../../../shared/dialog/services/dialog.service';
import { DialogContainerComponent } from '../../../shared/dialog/components/dialog-container/dialog-container.component';
import { InfoDialogComponent } from '../../../shared/dialog/components/dialogs/info-dialog/info-dialog.component';
import AudioHelper from "../../../audio/helpers/audio.helper";

@Component({
  selector: 'registration',
  templateUrl: './registration.component.html',
})
export class RegistrationComponent implements OnInit, OnDestroy {

  public activationCode: ActivationCodeModel = new ActivationCodeModel();
  public user: UserFormModel;
  public team: TeamModel;
  public validationErrors: RegistrationValidationErrors;

  protected audioHelper: AudioHelper;

  private dialog: DialogContainerComponent = null;
  private saveUserFormSubscription: Subscription = new Subscription();

  /**
   * Constructor
   *
   * @param {RegistrationService} registrationService
   * @param {ActivatedRoute} route
   * @param {Router} router
   * @param {AuthService} authService
   * @param {AppService} appService
   * @param {DialogService} dialogService
   * @param injector
   */
  public constructor(
    private registrationService: RegistrationService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private appService: AppService,
    private dialogService: DialogService,
    private injector: Injector,
  ) {
    this.validationErrors = new RegistrationValidationErrors();
    this.audioHelper = injector.get(AudioHelper);
  }


  /**
   * Initialize the Component
   *
   * @return void
   */
  public ngOnInit() {
    this.activationCode = this.registrationService.activation.activationCode;
    this.team = this.registrationService.activation.team || new TeamModel();
    this.user = this.registrationService.activation.userForm
      ? new UserFormModel(this.registrationService.activation.userForm)
      : new UserFormModel();
  }

  /**
   * When the component is destroyed
   *
   * @return void
   */
  public ngOnDestroy(): void {
    this.saveUserFormSubscription.unsubscribe();
  }

  /**
   * Submit the registration form
   *
   * @return void
   */
  public onSubmit(): void {
    this.saveUserFormSubscription = this.registrationService.saveUserForm(this.activationCode, this.user).pipe(
      concatMap(() => {

        this.dialog = this.dialogService.open(
          InfoDialogComponent,
          {title: 'auth.messages.registration.success', text: 'auth.messages.registration.redirecting'},
          );

        return this.authService.doFormLogin(this.user.username, this.user.password, false);

      }),
    ).subscribe(
      () => {

        this.router.navigate(['/']).then(
          () => {

            setTimeout(() => {
              if (this.dialog) {
                this.dialog.close();
              }
            }, 2000);
          },
        );
      },
      (error: {
        errors: RegistrationValidationErrors, message: { title: string, text: string }}) => {
        this.validationErrors = error.errors;
        this.audioHelper.playAudio('error');
      },

    );
  }
}
